export function getCookie(cname: string) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return '';
}

export function getObjectCookie(): Record<string, string> {
    const cookies: Record<string, string> = {};

    try {
        const cookieArray = document.cookie.split(';') || [];
        cookieArray.forEach((cookie) => {
            const [rawName, ...rawValueParts] = cookie.split('=');

            if (!rawName) return;

            const name = rawName.trim();
            const encodedValue = rawValueParts.join('=').trim();
            const value = decodeURIComponent(encodedValue);

            cookies[name] = value;
        });
    } catch (error) {
        //console.error('解析 cookie 时出错:', error);
    }

    return cookies;
}

export function getCookieUser() {
    let obj = {};
    try {
        const val1 = getCookie('userInfo') || '';
        const val2 = decodeURIComponent(val1);
        obj = JSON.parse(val2 || '{}');
    } catch (error) {}
    return obj;
}
